import { addTooltip } from './tooltip.js'

const copyIcons = document.querySelectorAll('#copy__icon')

copyIcons.forEach(copyIcon => {
    copyIcon.addEventListener('click', function () {
        var inputId = generateId(16);
        var body = document.querySelector('body');
        var input = document.createElement("textarea");
        var url = copyIcon.getAttribute("data-url");
        input.setAttribute("id", inputId);
        input.value = url;
        input.classList.add("copyUrlInput");
        body.appendChild(input);

        input.select();
        input.setSelectionRange(0, 99999); /* For mobile devices */

        /* Copy the text inside the text field */
        document.execCommand("copy");

        /* Removed input after copying the value */
        input.remove();

        addTooltip(copyIcon, 'URL Kopieret')
    });
})

function generateId(length) {
    var result = '';
    var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
}
